export default "__VITE_ASSET__3c3eff82__"